import * as React from 'react';
import Grid from '@material-ui/core/Grid';
import Translator from '../Translator/Translator';

class EnquiryResultTableViewHeader extends React.Component <{}, {}> {
    public render() {
        return (
            <div className="cmTableViewHeader">
                <Grid className="cmTableViewHeaderCol" item xs={5}>
                    <div className="cmTableViewHeaderContainer">
                        <div className="cmTableViewHeaderTitle">
                            <Translator path="enquiry.form.labels.chassisNumber">Chassis Number</Translator>
                        </div>
                    </div>
                </Grid>
                <Grid className="cmTableViewHeaderCol" item xs={4}>
                    <div className="cmTableViewHeaderContainer">
                        <div className="cmTableViewHeaderTitle">
                            <Translator path="enquiry.form.labels.licensePlate">License Plate Number</Translator>
                        </div>
                    </div>
                </Grid>
                <Grid className="cmTableViewHeaderCol" item xs={3}>
                    <div className="cmTableViewHeaderContainer">
                        <div className="cmTableViewHeaderTitle">
                            <Translator path="enquiry.form.labels.endDate">End Date</Translator>
                        </div>
                    </div>
                </Grid>
            </div>
        );
    }

}

export default EnquiryResultTableViewHeader;


// WEBPACK FOOTER //
// ./src/Components/Enquiry/EnquiryResultTableViewHeader.tsx